/* global google */

import { getLocations } from './query';
import { defer, createMap } from '../google-maps';

export function init() {
	let locations = [];
	let infoWindow;
	let isDrawerOpen = false;
	let bounds;
	let desktopBreakpoint = 1030;

	const canvas = document.querySelector('.js-location-map');
	const toggle = document.querySelector('.js-location-map-toggle');
	const drawer = document.querySelector('.js-location-map-drawer');

	if (!canvas || !toggle || !drawer) {
		return;
	}

	defer(go);

	let entryId = canvas.dataset.entryId;

	let viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	if (viewportWidth && viewportWidth >= desktopBreakpoint) {
		openDrawer();
	}

	function go() {
		const map = createMap(canvas, {
			center: { lat: 50.9433483, lng: -1.0169425 },
		});

		bounds = new google.maps.LatLngBounds();
		infoWindow = new google.maps.InfoWindow();

		getLocations(entryId).then(data => {
			if (data.lat && data.lng) {
				let marker = new google.maps.Marker({
					map: map,
					title: data.title,
					position: { lat: data.lat, lng: data.lng },
					icon: '/assets/icons/markers/property.svg',
				});

				bounds.extend(marker.position);

				marker.addListener('click', function onMarkerClick() {
					infoWindow.open(map, marker);
					infoWindow.setContent(`
						<h2 class="h4 u-mb-100">${data.title}</h2>
						<a class="cta-link" href="https://www.google.com/maps/search/?api=1&query=${data.lat},${data.lng}" target="_blank">View on Google Maps</a>
					`);
				});
			}

			data.locations.forEach((location) => makeMarker(location, map));
			map.fitBounds(bounds);
		});

		map.addListener('click', handleMapClick);
	}

	function makeMarker(location, map) {
		let marker = new google.maps.Marker({
			map: map,
			title: location.title,
			position: { lat: location.lat, lng: location.lng },
			icon: '/assets/icons/markers/default.svg',
		});

		bounds.extend(marker.position);

		locations.push({ ...location, marker });

		marker.addListener('click', function onMarkerClick() {
			infoWindow.open(map, marker);
			infoWindow.setContent(`
				<h2 class="h4 u-mb-100">${location.title}</h2>
				<a class="cta-link" href="https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}" target="_blank">View on Google Maps</a>
			`);
		});
	}

	drawer.addEventListener('change', update);
	toggle.addEventListener('click', () => isDrawerOpen ? closeDrawer() : openDrawer());

	function getSelectedCategoryIds() {
		return Array.from(drawer.querySelectorAll('input'))
			.filter(elem => elem.checked)
			.map(elem => Number(elem.value));
	}

	function update() {
		let selectedCategoryIds = getSelectedCategoryIds();

		Object.values(locations).forEach(location => {
			let categoryIds = location.categories.map(category => Number(category.id));
			let categorySelected = categoryIds.some(id => selectedCategoryIds.includes(id));

			location.marker.setVisible(categorySelected);
		});
	}

	function openDrawer() {
		if (isDrawerOpen) {
			return;
		}

		isDrawerOpen = true;
		drawer.classList.add('is-open');
		toggle.classList.add('is-open');
	}

	function closeDrawer() {
		if (!isDrawerOpen) {
			return;
		}

		isDrawerOpen = false;
		drawer.classList.remove('is-open');
		toggle.classList.remove('is-open');
	}

	function handleMapClick() {
		closeDrawer();
		infoWindow.close();
	}
}
